export default __webpack_public_path__ + "static/media/Smart-Manufacturing-Revolutionizing-the-Industry-with-AI-and-Data-Analytics.6d46096b.mp4";